<template>
    <div>
        <b-container class="container-panel">
            <b-row align-v="end">
                <b-row class="p-1" align-v="end">
                    <b-col cols="4">
                        <img src="@/assets/ambit-cares.jpg"
                             class="logo-margin"
                             alt="Ambit Logo"
                             aria-label="Ambit Logo" />
                    </b-col>
                </b-row>
                <b-col cols="8">
                    <span class="page-title align-center">{{$t('VERIFYING')}}</span>
                </b-col>
            </b-row>
        </b-container>

        <b-container>
            <b-row>
                <b-col cols="12"
                       class="d-flex justify-content-center mb-3 make-space-above ambit-orange">
                    <b-spinner></b-spinner>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import Repo from '../repo';

    export default {
        name: "Donation",
        data: () => ({
            donorType: '',
            donorNumber: '',
            donorName: '',
            amount: 0.0,
            zipCode: '',
            locationCode: ''
        }),
        mounted() {

            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            // set up the initial data (from the parsing of the route)
            this.donorType = this.capitalizeFirstLetter(this.$route.params.accountType);

            // two exclamation marks (!!) does a test for truthiness (it is two NOTs (!))
            // this is a consultant or customer if there is an account number coming in
            const isConsultantOrCustomer = !!this.$route.params.accountNumber;

            if (this.$route.params.accountNumber) {
                this.donorNumber = this.$route.params.accountNumber;
            }

            if (this.$route.params.donorName) {
                this.donorName = decodeURI(this.$route.params.donorName);
            }

            this.amount = this.$route.params.amount;
            if (this.amount <= 0) {
                this.$store.dispatch('shell/addErrorMessages', 'Donation amount must be greater than 0.');
            }
            this.locationCode = this.$route.query.locationCode;
            // check the validity of that data
            if (!this.donorType) {
                this.$store.dispatch('shell/addErrorMessages', 'Missing Donor Type');
            } else if (['Consultant', 'Employee', 'Customer', 'Friend'].indexOf(this.donorType) < 0) {
                this.$store.dispatch('shell/addErrorMessages', `Incorrect Donor Type: [${this.donorType}]`);
            }

            if (isConsultantOrCustomer) {
                if (!this.donorNumber) {
                    this.$store.dispatch('shell/addErrorMessages', 'Missing Donor Number');
                } //else if (!this.donorNumber.match(constants.cNumberRegex)) {
                //    this.$store.commit('lobby/ADD_ERROR_MESSAGES', `Incorrectly formatted Donor Number: [${this.donorNumber}]`)
                //}

                // Only customers and consultants get zip codes in their URLs
                // 08/2025 Only validate if its not a Consultant
                this.zipCode = this.$route.params.zipCode
                if (this.donorType.toUpperCase() !== 'CONSULTANT') {
                    if (!this.zipCode) {
                        this.$store.dispatch('shell/addErrorMessages', 'Missing Zip Code');
                    } else if (this.zipCode.length !== 5 || Number.isNaN(Number(this.zipCode))) {
                        this.$store.dispatch('shell/addErrorMessages', `Incorrectly formatted Zip Code: [${this.zipCode}]`)
                    }
                }
            }

            if (!isConsultantOrCustomer) {
                if (!this.donorName) {
                    this.$store.dispatch('shell/addErrorMessages', 'Missing Donor Name');
                }
            }

            if (!this.amount) {
                this.$store.dispatch('shell/addErrorMessages', 'Missing Amount');
            } else if (Number.isNaN(Number(this.amount))) {
                this.$store.dispatch('shell/addErrorMessages', `Incorrectly formatted Donation Amount: [${this.amount}]`)
            }

            //don't get paymenttoken if there are errors
            if (!this.anyErrors) {
                // we are all set to go, so go to the server to verify that everything is good (for Consultants and Customers)
                if (isConsultantOrCustomer) {
                    this.validateDonor();
                } else {
                    // we don't need to go to the server for friends or employees
                    const request = {
                        ExternalKeyType: this.donorType,
                        AccountHolderName: this.donorName,
                        Amount: this.amount,
                        LocationId: this.locationCode,
                        CallBackUrl: this.callBackUrl,
                        DisplayLanguageOptions: ['en','sp'],
                        PaymentCampaignCode: 'DONATIONS',
                        CountryCode: 'US'
                    }
                    this.getPaymentToken(request);
                }
            }
        },
        computed: {
            ...mapGetters({
            anyErrors: 'shell/anyErrors'
            }),
            callBackUrl() {
                var url = window.location.href;
                if (url.includes("localhost") || url.includes("int")) {
                    return "https://int.ambitcares.org";
                } else {
                    return "https://ambitcares.org";
                }
            }
        },
        methods: {
            getPaymentToken: function (request) {
                this.$store.dispatch('lobby/getPaymentToken', request);
            },
            capitalizeFirstLetter(someString) {
                return someString[0].toUpperCase() + someString.slice(1).toLowerCase();
            },
            validateDonor: function () {
                const infoMessage = 'To verify your account information, please contact customer care at 877-282-6284.';
                const zipCodeNote = '(provided zipcode does not match account information).';
                // store these locally so that they don't get lost while processing promises
                  var request = {
                    DonorType: this.donorType,
                    DonorNumber: this.donorNumber,
                    ZipCode: this.zipCode
                }
                // go up to the server to get the rest of the data
                Repo.DonationService.IsDonorValid(request)
                    .then((result) => {                        
                            if (result.isValid) {
                                // This is the HAPPY PATH
                                    const request = {
                                        Amount: this.amount,
                                        ExternalKeyType: this.donorType,
                                        ExternalKeyValue: this.donorNumber.toUpperCase(),
                                        CallBackUrl: this.callBackUrl,
                                        DisplayLanguageOptions: ['en','sp'],
                                        PaymentCampaignCode: 'DONATIONS',
                                        CountryCode: result.isCanadian ? 'CA' : 'US'
                                    }
                                    this.getPaymentToken(request);
                                    return;
                            }
                                this.$store.dispatch('shell/addErrorMessages', `Zipcode mis-match for ${this.donorType} ${zipCodeNote} ${infoMessage}`);
                                return;
                        // if I get here, something went wrong, so...
                        this.$store.dispatch('shell/addErrorMessages', `Error accessing ${this.donorType} account. ${infoMessage}`);
                    })
                    .catch((ex) => {
                        this.$store.dispatch('shell/addErrorMessages', `Exception accessing ${this.donorType} account. (ex: ${ex.message})`);
                    });
            },
        }
    }
</script>